import { Injectable } from "@angular/core";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

const CSV_TYPE = "text/csv;charset=UTF-8";

const EXCEL_EXTENSION = ".xlsx";
const CSV_EXTENSION = ".csv";
@Injectable()
export class ExcelService {
  constructor() {}
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    // + '_export_' + new Date().getTime() +
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  public exportCsvFIle(json: any[], excelFileName: string): void {
    if (!json || json.length === 0) return;

    const cabecalhos = Object.keys(json[0]);
    const linhaCabecalho = cabecalhos.join(';');

    const linhasData = json.map(obj => {
      return cabecalhos.map(campo => {
        let valor = obj[campo] ?? '';

        if (typeof valor === 'string') {
          valor = valor
            .replace(/\r\n|\r|\n/g, ' ')
            .replace(/;/g, ' ');
        }

        return valor;
      }).join(';');
    });

    const csvString = [linhaCabecalho, ...linhasData].join('\r\n');

    this.saveAsCsvFile(csvString, excelFileName);
  }

  private saveAsCsvFile(buffer: any, fileName: string) {
    const SEP_HEADER = "sep=;\r\n";
    const fullContent = SEP_HEADER + buffer;

    const charArray = fullContent.split('').map(char => char.charCodeAt(0));
    const encoded = new Uint8Array(charArray);

    const data = new Blob(
      [encoded], { type: 'text/csv;charset=windows-1252' }
    );

    FileSaver.saveAs(data, fileName + CSV_EXTENSION);
  }
}
